import { rewriteCmsImageUrls } from '@packages/shared/src/utils/rewriteCmsImageUrls/rewriteCmsImageUrls';
import type { FooterBlockListType } from '../types';

type BlockListProps = {
  data: FooterBlockListType;
};

export enum BlockListTestIds {
  main = 'block-list',
}

export const BlockList = ({ data }: BlockListProps) => (
  <div
    className="_c_cms_footerlist"
    data-testid={BlockListTestIds.main}
    key={`${BlockListTestIds.main}-${data.id}`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: rewriteCmsImageUrls(data.field_html_editor) }}
  />
);
